import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { EBusinessStatus, EBusinessType, IBusinessItem, IPortConfigDetail, IPortConfigParams, IPortConfiguration } from '../../types';

const hostUrl = getHostbaseUrl();

/**
 * 系统配置 - 端口配置
 */
export async function queryBusinessPage(params: IPortConfiguration) {
  let data = [] as IBusinessItem[];
  let total = 0;

  try {
    const { code, context, message } = await Http.post<{ data: IBusinessItem[]; total: number }>(`${hostUrl}/iam/business/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IBusinessItem[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total, 
  };
}

/**
 * 系统配置 - 修改默认状态
 */
export async function updateBusinessStatus(params: {businessId: number; isDefault: EBusinessStatus}) {
  try {
    const { code, message } = await Http.put<{businessId: number; isDefault: EBusinessStatus}>(`${hostUrl}/iam/business/status`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 系统配置 - 修改默认状态
 */
export async function managePortService(params: IBusinessItem, isAdd: boolean) {
  try {
    const { code, message } = isAdd ? 
      await Http.post<IBusinessItem>(`${hostUrl}/iam/business`, params) : 
      await Http.put<IBusinessItem>(`${hostUrl}/iam/business/name`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 系统配置 - 获取业务配置
 */
export async function queryBusinessDetail(params: {businessId: number; businessType: EBusinessType}) {
  let data = {} as IPortConfigDetail;

  try {
    const { code, context, message } = await Http.post<IPortConfigDetail>(`${hostUrl}/iam/business/config/detail`, params); 

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || {} as IPortConfigDetail;

      data = items || {} as IPortConfigDetail;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  return data;
}

/**
 * 系统配置 - 修改业务配置
 */
export async function updateBusinessDetail(params: IPortConfigParams) {

  try {
    const { code, message } = await Http.put<IPortConfigParams>(`${hostUrl}/iam/business/config`, params); 

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}